/**
 * Utility functions for formatting shared assessment data
 */

// Money/date formatting lives in one place - see utils/formatters.ts.
// Re-exported here so existing assessment imports keep working.
export { formatCurrency, formatPercentage, formatDate } from './formatters';

/**
 * Get the recommended option from the comparison data.
 *
 * The backend recommendation union is 'fullFee' | 'noFee' | 'none'. 'none'
 * means neither refinance option beats the current loan, so callers must not
 * present a recommendation - this returns an explicit label for that case
 * instead of silently falling through to "Full-Fee Refinance".
 */
export function getRecommendedOption(recommendation: 'noFee' | 'fullFee' | 'none'): string {
  switch (recommendation) {
    case 'noFee':
      return 'No-Fee Refinance';
    case 'fullFee':
      return 'Full-Fee Refinance';
    case 'none':
    default:
      return 'No refinance recommended at this time';
  }
}

/**
 * Calculate first year impact from monthly savings
 */
export function calculateFirstYearImpact(monthlySavings: number): number {
  return monthlySavings * 12;
}
